import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as uuid from 'uuid';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import { tableConfig } from '../../../settings/index';
import notifications from '../../../redux/notifications/actions';
import actions from './actions';
import Api from '../../../helpers/api';

const api = new Api('dashboard/unmatched_bookings');

const provideUniqueIds = array => {
  return array && array.length > 0 ? array.map(item => ({ ...item, id: uuid.v4() })) : [];
};

function* loadDatRequest({ payload }) {
  try {
    const { company_id, page = 1, pageSize = tableConfig.pageSize, filter = '' } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      {
        search: { page, pageSize, filter, ...payload, column: 'unmatched_jobs', order: 'descend' },
        id: company_id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, filters, sortableColumns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: provideUniqueIds(records),
          filters,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadDatRequest)]);
}
